import React, { Component, Fragment } from "react"
import moment from "moment"
import QrCode from "../Common/QrCode"

export default class PrintSample extends Component {
    state = {
        sampleMain: null,
        toggle: null,
        bno:null
    }

    componentWillMount() {
        const { toggle, sampleMain, bno } = this.props
        this.setState({
            toggle,
            sampleMain,
            bno
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sampleMain != this.props.sampleMain) {
            this.setState({
                sampleMain: nextProps.sampleMain
            })
        }
        if (nextProps.toggle != this.props.toggle) {
            this.setState({
                toggle: nextProps.toggle
            })
        }
    }
    render() {
        const { sampleMain, toggle, bno } = this.state
      
        return (
            <Fragment>
                <div className="fabricPrintDiv">
                    <style>
                        {`@media print {
                body{
                    font-family: 'Montserrat', sans-serif;
                    font-size:11px;
                    box-sizing: border-box
                }
                .fabricPrintDiv{
                    border : 2px solid black;
                    top : 0;
                    bottom : 0;
                }

                .printrow {

                    width: 100%;
                }

                .printcolumn {
                    display: flex;
                    flex-direction: column;
                    flex-basis: 100%;
                    flex: 1;
                }
                table>tbody>tr td{
                    font-size:8px;
                    text-align:center;
                }
                .label-text{
                    color:#279588;
                    font-size : 11px;
                    font-weight:bold;
                    text-decoration: underline;
                }
                .blue{
                    color : #146FF9;
                }
                .padding-for-heading{
                    padding: 5px;
                }

                .specialComments{
                    width: 75%;
                    border : 1px solid black;
                    height : 60px;
                    margin: 10px;
                }

                .b{
                    border: 1px solid black;
                    margin: 10px;
                    padding: 5px;
                }
                .fabric-text{
                    font-size:16px;
                    color: #279588;
                    font-weight: 1000;
                }

                .bold{
                    font-weight:bold;
                    font-size: 9px;
                }
                .bb-p{
                    border-bottom: 1px solid black;
                    margin-bottom: 10px ;
                }

                .bb-pp{
                    margin-bottom: 10px ;
                }
                .w-50 {
                    width: 50%;
                }
                table.grid{
                    border-collapse: collapse;
                    margin-right: 5px;
                    margin-left: 5px;
                }
                table.grid>tbody>tr td {
                    border: 0.5px solid black;
                    text-align: center;
                    padding: 2px;
                }

                .textAlignLeftOnly {
                    text-align: left;
                    padding: auto 10px;
                    margin: auto 10px
                }

                .textAlignRightOnly {
                    text-align: right;
                    padding: auto 10px;
                    margin: auto 10px
                }

                .marginPadding {
                    padding: 20px
                    margin: 20px 10px 10px 10px
                }
                .width-for-table{
                    width: 50%;
                }
                .text-center{
                    text-align: center !important;
                }
                .p-1{
                    padding : 5px;
                }
                .pl-1{
                    padding-left: 23px;
                }
                .border-bot{
                    border-bottom : 1px solid black;
                }
                .mt{
                    margin-top:10px;
                }
                .mtl{
                    margin-top:30px;
                }
                .margin{
                    margin : 5px;
                }
                .pl-2{
                    padding: 5px;
                }
                .table-heading{
                    padding-left:5px;
                    margin:0;
                    color:#4285f4;
                    text-transform:uppercase;

                }

                .text-capitalize{
                    text-transform: capitalize;
                }

                .padding-option{
                    padding:0px 20px 0px 60px;

                }
                .paddingLeft{
                    left:100px !important;
                }
                table{
                    width:100%;
                }
                .test-class{
                    width:40%;

                    display:inline-block
                }
                .test-class1{
                    width:20%;
                    display:inline-block
                }
                .test-class2{
                    width:40%;
                    display:inline-block
                }
                .float-left{
                    float:left !important;
                }

                .padding-align-qc{
                    padding-left: 42%!important;
                }
                .text-right{
                    text-align:right !important;
                }
                .title-color{
                    padding-left:5px;
                    margin:0;
                    color:#0033cc;
                }
                .total-title-color{
                    color:#0066ff;
                }
                .float-right{
                    float:right !important;
                }
                .col-md-6{
                    width:50% !important;
                }
                .label-color{
                    color:#279588;
                    padding-left:5px;
                    margin:0;
                }
               .total-value-calc{
                   display:flex;
                   flex-direction:row-reverse;
                   padding:0 !important;
               }
               .col-md-9{
                   width:75% !important;
               }
               .col-md-3{
                   width: 25% !important;

               }
               .col-md-4{
                   width:33.3% !important;
               }
               .height-value{
                   height:160px !important;
               }
               .comments-height{
                   height: 55px !important;
               }
               .text-area-border{

                   border: 2px solid black !important;
               }

                table { page-break-inside:auto }
                tr    { page-break-inside:avoid; page-break-after:auto }
                thead { display:table-header-group }
                tfoot { display:table-footer-group }

                .last-row {
                    page-break-after  : auto
                }
                }`}
                    </style>
                    <div className="bold text-center p-1 ">
                        MAGNUM CLOTHING PVT LTD - SAMPLE REQUEST SHEET
                    </div>
                    <div className="printrow bb-p">
                        <div className="text-capitalize">
                            <table>
                                <tbody>
                                    <tr>
                                        <td colSpan="2" rowSpan="5">
                                            <span>{sampleMain.requestNumber}</span>
                                            <QrCode qr={sampleMain.qr} />
                                            <span className="bold" style={{ fontSize: "0.7rem" }}>Dated {sampleMain.createdAt ? moment(sampleMain.createdAt).format("HH:mm DD MMM YYYY") : ""} </span>
                                        </td>
                                        <td className="label-text">style no</td>
                                        <td className="label-text">Cust ref no</td>
                                        <td className="label-text">customer-dept</td>
                                        <td className="label-text">Mag style name</td>
                                        <td className="label-text">buyer style name</td>
                                        <td className="label-text">Item No</td>
                                        <td className="label-text">source of request</td>
                                    </tr>
                                    <tr>
                                        <td className="bold">{sampleMain.styleRefNo}</td>
                                        <td className="bold">{sampleMain.customerRefNumber}</td>
                                        {/* <td className="bold">{`${sampleMain.customer} - ${sampleMain.departmentName}`}</td> */}
                                        <td className="bold">{`${sampleMain.customer}`}</td>
                                        <td className="bold">{sampleMain.magnumStyleName}</td>
                                        <td className="bold">{sampleMain.buyerName}</td>
                                        <td className="bold">{sampleMain.itemNumber}</td>
                                        <td className="bold">{sampleMain.typeOfRequest}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-text">old mag. ref no</td>
                                        <td className="label-text">block ref no </td>
                                        <td className="label-text">origin of request</td>
                                        <td className="label-text">magnum tech</td>
                                        <td className="label-text">sample type</td>
                                        {/* <td className="label-text">Bno</td> */}
                                    </tr>
                                    <tr>
                                        <td className="bold"> {sampleMain.oldMagStyleNo}</td>
                                        <td className="bold">{sampleMain.blockRefNo}</td>
                                        <td className="bold">
                                            {sampleMain.originationOfRequest}
                                        </td>
                                        <td className="bold">{sampleMain.magnumTechnologist}</td>
                                        <td className="bold">{sampleMain.sampleType}</td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="printrow bb-p">
                        <div className="text-capitalize">
                            <table>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tbody>
                                    <tr>
                                        <td className="label-text">fabric no</td>
                                        <td className="label-text">Fabric Name</td>
                                        <td className="label-text">position</td>
                                        <td className="label-text">Base No</td>
                                        <td className="label-text">classification of fabric</td>
                                        <td className="label-text">quality</td>
                                        <td className="label-text">count & construction</td>
                                        <td className="label-text">Fabric Origination</td>
                                    </tr>

                                    {/* Start of map */}
                                    {sampleMain.sampleFabric && sampleMain.sampleFabric.fabricArray && sampleMain.sampleFabric.fabricArray.length > 0 && sampleMain.sampleFabric.fabricArray.map((fab, index) => {
                                        return (
                                            <tr>
                                                <td className="bold">{fab.fabricNumber}</td>
                                                <td className="bold">{sampleMain.fabricName[index]}</td>
                                                <td className="bold">{fab.fabricPosition}</td>
                                                <td className="bold">{sampleMain.bNumber[index]}</td>
                                                <td className="bold">{fab.classificationOfFabric}</td>
                                                <td className="bold">{fab.quality}</td>
                                                <td className="bold">{fab.countAndConstruction}</td>
                                                <td className="bold">{fab.fabricOrigination}</td>
                                            </tr>
                                        )
                                    })}

                                    {/* End of map */}
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td className="label-text">trim category</td>
                                        <td className="label-text">trim no</td>
                                        <td className="label-text">Description</td>
                                        <td className="label-text">quality</td>
                                        <td className="label-text">size</td>
                                    </tr>
                                    {/* Start of map */}
                                    {sampleMain.sampleTrim && sampleMain.sampleTrim.trimArray && sampleMain.sampleTrim.trimArray.length > 0 && sampleMain.sampleTrim.trimArray.map((trim, index) => {
                                        return (
                                            <tr>
                                                <td className="bold">{trim.trimCategory}</td>
                                                <td className="bold">{trim.trimNumber}</td>
                                                <td className="bold">{trim.description}</td>
                                                <td className="bold">{trim.quality}</td>
                                                <td className="bold">{trim.sizeNumber} - {trim.size}</td>
                                            </tr>
                                        )
                                    })}

                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>

                                    <tr>
                                        <td className="label-text">size</td>
                                        <td className="label-text">qty</td>
                                        <td className="label-text">Wash</td>
                                        <td className="label-text">Ref Color</td>
                                    </tr>
                                    <tr>
                                        <td className="bold">
                                            {sampleMain.sampleFabric && sampleMain.sampleFabric.sampleArray.length > 0 && sampleMain.sampleFabric.sampleArray.map((sam, index) => {
                                                return (
                                                    <Fragment>
                                                        <p className="bold" style={{ color: "#000 !important" }}>{sam.size}</p>
                                                    </Fragment>
                                                )
                                            })}
                                        </td>
                                        <td className="bold">
                                            {sampleMain.sampleFabric && sampleMain.sampleFabric.sampleArray.length > 0 && sampleMain.sampleFabric.sampleArray.map((sam, index) => {
                                                return (
                                                    <Fragment>
                                                        <p className="bold" style={{ color: "#000 !important" }}>{sam.quantity}</p>
                                                    </Fragment>
                                                )
                                            })}
                                        </td>
                                        <td className="bold">{
                                            <Fragment>
                                                <p className="bold" style={{ color: "#000 !important" }}>{sampleMain.washType || "No WASH"}</p>
                                            </Fragment>
                                        }</td>
                                        <td className="bold">{sampleMain.refColNo}</td>
                                    </tr>

                                    {/* End of map */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="printrow bb-pp">
                        <div className="text-capitalize">
                            <table className=" marginPadding" colSpan="12">
                                <tr
                                    style={{
                                        display: "flex",
                                        textAlign: "left",
                                        padding: "5px 10px 12px 10px",
                                        borderBottom: "2px dotted #000"
                                    }}
                                >
                                    <th style={{ flexGrow: "4" }} className="label-text ">
                                        Comments
                                    </th>
                                    <th style={{ margin: "0 10px" }} className="label-text ">
                                        date
                                    </th>
                                    <th style={{ margin: "0 5px" }} className="label-text">
                                        sign
                                    </th>
                                </tr>
                                <tbody className=" marginPadding" colSpan="12">
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0",
                                            borderBottom: "2px dotted #000"
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    <tr
                                        style={{
                                            display: "flex",
                                            textAlign: "left",
                                            padding: "0px 10px 2px 10px",
                                            marginTop: "0", 
                                        }}
                                    >
                                        <td
                                            style={{
                                                flexGrow: "4",
                                                textAlign: "left",
                                                padding: "15px auto",
                                                marginTop: "0",
                                                marginBottom: "15px;"
                                            }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "15px" }}
                                            className="bold "
                                        ></td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                            {/* SAMPLE'S BASIC INFO TABLE END */}
                        </div>
                    </div>

                    <div className="printrow bb-pp last-row">
                        <div className="text-capitalize">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="label-text">GMT TECH</td>
                                        <td className="label-text">PATTERN</td>
                                        <td className="label-text">3D</td>
                                        <td className="label-text">CUTTING</td>
                                        <td className="label-text">SEWING</td>
                                        <td className="label-text">EMBROIDERY</td>
                                        <td className="label-text">EMBELLISHMENT</td>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr style={{ padding: "20px", margin: "10px auto", borderBottom: "2px dotted #000" }}>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.garmentTechnologist ? "" : "N/A"}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.pattern ? "" : "N/A"}
                                        </td>
                                        <td className="label-text">
                                            {toggle.pattern ? "" : "N/A"}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.cutting ? "" : "N/A"}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.sewing ? "" : "N/A"}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.embroidery ? "" : "N/A"}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.embellishment ? "" : "N/A"}
                                        </td>
                                    </tr>
                                    <tr style={{
                                        borderBottom: "2px dotted #000"
                                    }}>
                                        <td className="label-text">DISPATCH</td>
                                        <td className="label-text">GRADING</td>
                                        <td className="label-text">MARKER</td>
                                    </tr>

                                    <tr style={{ padding: "20px", margin: "10px auto", borderBottom: "2px dotted #000" }}>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.dispatch ? "" : "N/A "}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.qc ? "" : "N/A"}
                                        </td>
                                        <td
                                            style={{ margin: "0 5px", paddingBottom: "30px" }}
                                            className="bold"
                                        >
                                            {toggle.marker ? "" : "N/A "}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

// Old Layout, for Backup

// *SAMPLE'S INFO TABLE START
//                     {
//                         <div className="printrow bb-p">
//                             <p className="table-heading">sample details</p>
//                             <div className="test-class">
//                                 <div className="text-capitalize">

//                                     <table>

//                                         <tbody>
//                                             <tr>
//                                                 <td className="label-text">awaiting dev sample</td>
//                                                 <td className="label-text">awaiting design sheet</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="bold">test</td>
//                                                 <td className="bold">test</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>

//                                 </div>

//                             </div>
//                             <div className="test-class1">
//                                 <div className="text-capitalize">

//                                     <table>

//                                         <tbody>
//                                             <tr>
//                                                 <td className="label-text">size</td>
//                                                 <td className="label-text">Qty</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="bold">test</td>
//                                                 <td className="bold">test</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>

//                                 </div>
//                             </div>
//                             <div className="test-class2">
//                                 <div>
//                                     <p className="table-heading float-left">SMOCKING/SHIRRING :</p>
//                                     <p className="padding-option">YES/NO</p>
//                                     <p className="table-heading float-left">COMMENTS :</p>
//                                     <p className="padding-option">sample details</p>
//                                 </div>
//                             </div>
//                             <div className="text-capitalize">
//                                 <p className="table-heading">CAD</p>

//                                 <table>

//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">cad ref no</td>
//                                             <td className="label-text">cad type</td>
//                                             <td className="label-text">completed date</td>

//                                         </tr>
//                                         <tr>

//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>

//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* SAMPLE'S INFO TABLE END */}

//                     {/* FABRIC'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">fabric</p>

//                                 <table>

//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">fabric ref no</td>
//                                             <td className="label-text">position</td>
//                                             <td className="label-text">classification of fabric</td>
//                                             <td className="label-text">quality</td>
//                                             <td className="label-text">count & construction</td>
//                                             <td className="label-text">completed date</td>

//                                         </tr>
//                                         <tr>

//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>

//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* FABRIC'S INFO TABLE END */}

//                     {/* TRIM'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">trims</p>

//                                 <table style={{ width: '100%' }}>
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">trim category</td>
//                                             <td className="label-text">trim ref no</td>
//                                             <td className="label-text">description</td>
//                                             <td className="label-text">quality</td>
//                                             <td className="label-text">size</td>
//                                             <td className="label-text">completed date</td>

//                                         </tr>
//                                         <tr>

//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>

//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* TRIM'S INFO TABLE END */}

//                     {/* PATTERN'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">pattern</p>

//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">pattern master name</td>
//                                             <td className="label-text">pattern type</td>
//                                             <td className="label-text">Block ref used</td>
//                                             <td className="label-text">trial reqd</td>
//                                             <td className="label-text">completed date</td>

//                                         </tr>
//                                         <tr>

//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>

//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* PATTERN'S INFO TABLE END */}

//                     {/* CUTTING'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">cutting</p>

//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">cutting master name</td>
//                                             <td className="label-text">cutting type</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* CUTTING'S INFO TABLE END */}

//                     {/* SEWING'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">sewing</p>

//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">place of sewing</td>
//                                             <td className="label-text">tailor name</td>
//                                             <td className="label-text">sewing type</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* SEWING'S INFO TABLE END */}

//                     {/* EMBROIDERY'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize ">
//                                 <p className="table-heading">embroidery&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;embelishment</p>
//                                 {/* <p className="table-heading paddingleft">embelishment</p> */}
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td colspan="1"></td>
//                                             <td className="label-text">type</td>
//                                             <td className="label-text">HH : MM</td>
//                                             <td className="label-text">price/30 Mins</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td></td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* EMBROIDERY'S INFO TABLE END */}

//                     {/* WASH'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">wash</p>

//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text ">wash type</td>
//                                             <td className="label-text ">wash form</td>
//                                             <td className="label-text ">laundary unit</td>
//                                             <td className="label-text ">no of mocks</td>
//                                             <td className="label-text ">tacking</td>
//                                             <td className="label-text ">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     }
//                     {/* WASH'S INFO TABLE END */}

//                     {/* DISPATCH'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize ">
//                                 <p className="table-heading float-left">dispatch</p>
//                                 <p className="table-heading  padding-align-qc">QC</td>

//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">magnum counter</td>
//                                             <td className="label-text">any issues?</td>
//                                             <td className="label-text">reason?</td>
//                                             <td className="label-text">completed date</td>

//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>

//                                         </tr>
//                                     </tbody>
//                                 </table>

//                             </div>
//                         </div>
//                     } */
//                     {/* DISPATCH'S INFO TABLE END */}


// WEBPACK FOOTER //
// ./src/components/printSample/index.js